import React, { FC } from 'react'
import { Heading } from 'LibNeo'
import { SuccessModalDescription, SuccessModalWrapper } from './styled'

interface ComponentProps {
	email?: string
}

export const SuccessRestartModal: FC<ComponentProps> = ({ email }): JSX.Element => {
	return (
		<SuccessModalWrapper>
			<Heading type="h4">Заявка успешно отправлена!</Heading>
			<SuccessModalDescription>
				{`Ожидайте уведомление о рестарте на вашу электронную почту ${email}
					от support@dasreda.ru в течение 24 часов.`}
			</SuccessModalDescription>
		</SuccessModalWrapper>
	)
}
